<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="INTEGRACIONES Y FUNCIONES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="7">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-4">
              <ValidationProvider rules="required" name="location" style="width: 100%" v-slot="{ valid, errors }">
                <Label label="Ubicación o nombre de acceso" :blank="form.location" show-reset @reset="form.location = null" />
                <b-input-group size="lg">
                  <b-input
                    v-model="form.location"
                    type="text"
                    :state="errors[0] ? false : (valid ? true : false)"
                    trim
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>

            <b-row v-if="!controlAcceso.access_control_type_id" class="mb-4">
              <b-col class="px-0">
                <b-alert show variant="warning" class="text-center mb-0  px-2 py-1 d-flex align-items-center justify-content-center">
                  <font-awesome-icon :icon="['far', 'exclamation-triangle']" size="lg" fixed-width class="text-warning" />
                  <span class="ml-1 fs-20">
                    Debe seleccionar el <b>paso a controlar</b> en el paso anterior
                  </span>
                </b-alert>
              </b-col>
            </b-row>

            <div v-else>
              <component
                v-if="accessControlComponent"
                :is="accessControlComponent"
                :form="form"
                :detailsForm="detailsForm"
              />
            </div>

            <b-alert v-if="integrationNotesRequired" variant="warning" show class="mb-3">
              <p class="mb-2 d-block ml-3 font-weight-bold fs-15">
                <BlankIcon :field="null"/>
                Se requieren detalles adicionales
              </p>
              <p class="mb-0 fs-15">
                Uno o más campos de las opciones de la imagen tienen el valor de "Especial". Debe describir en <strong>notas generales</strong> el detalle de las integraciones o funciones especiales necesarias
              </p>
            </b-alert>

            <StepNotes
              :value="form.integration_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import Label from '../Label'
import StepNotes from '../StepNotes'

// pasos vehiculares
import barreraAutomatica from './Integrations/barreraAutomatica'
import abatible from './Integrations/abatible'
import corredizo from './Integrations/corredizo'
import seccional from './Integrations/seccional'
import cortina from './Integrations/cortina'
import bolardos from './Integrations/bolardos'
// pasos peatonales
import peatonalManual from './Integrations/peatonalManual'
import puertaAutomatica from './Integrations/puertaAutomatica'
import cerraduraElectronica from './Integrations/cerraduraElectronica'
import cerraduraSalto from './Integrations/cerraduraSalto'
import torniquete from './Integrations/torniquete'
import pasoRapido from './Integrations/pasoRapido'
import pasoLey7600 from './Integrations/pasoLey7600'
import BlankIcon from '../BlankIcon'

const ACCESS_CONTROL_COMPONENTS = {
  barrera_automatica: barreraAutomatica,
  abatible: abatible,
  corredizo: corredizo,
  seccional: seccional,
  cortina: cortina,
  bolardos: bolardos,
  pasos_rapidos: pasoRapido,
  peatonal_manual: peatonalManual,
  puerta_automatica: puertaAutomatica,
  cerradura_electronica: cerraduraElectronica,
  cerradura_salto: cerraduraSalto,
  torniquetes: torniquete,
  paso_ley_7600: pasoLey7600
}


export default {
  name: 'General',
  components: {
    ConfiguratorStepTitle,
    ValidationObserver,
    ValidationProvider,
    Label,
    StepNotes,
    barreraAutomatica,
    abatible,
    corredizo,
    seccional,
    cortina,
    bolardos,
    peatonalManual,
    puertaAutomatica,
    cerraduraElectronica,
    cerraduraSalto,
    torniquete,
    pasoRapido,
    pasoLey7600,
    BlankIcon
  },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      processing: false,
      form: {
        location: '',
        integration_notes: ''
      },
      detailsForm: {
        remote_device: null,
        entry_device_1: null,
        entry_device_2: null,
        exit_device_1: null,
        exit_device_2: null,
        safety_sensors: null,
        entry_sensor: null,
        exit_sensor: null,
        boom_length: 0,
        alerts: null,
        support_post: null,
        breakaway: null,
        articulated: null,
        door_closer: null,
        lock_type: null,
        main_lock: null,
        mounting_type: null,
        door_thickness: 0,
        lock_thickness: 0,
        handle_height: 0,
        handle_offset: 0,
        exterior_door: null,
        door_prepared_for_lock: null,
        has_reliable_wifi: null,
        configure_proximity: null,
        configure_code: null,
        configure_fingerprint: null,
        configure_mobile: null,
        requires_temporary_codes: null,
        hardware_standard: null,
        backset: 0,
        axe_distance: 0,
        faceplate_type: null,
        faceplate_width: 0,
        faceplate_length: 0,
        cover_plate: null,
        locking_devices: null
      }
    }
  },
  mounted () {
    if (this.controlAcceso) {
      this.form.location = this.controlAcceso.location
      this.form.integration_notes = this.controlAcceso.integration_notes

      const accessControlDetail = this.controlAcceso.access_control_detail
      if (accessControlDetail) {
        this.detailsForm.remote_device = accessControlDetail.remote_device
        this.detailsForm.entry_device_1 = accessControlDetail.entry_device_1
        this.detailsForm.entry_device_2 = accessControlDetail.entry_device_2
        this.detailsForm.exit_device_1 = accessControlDetail.exit_device_1
        this.detailsForm.exit_device_2 = accessControlDetail.exit_device_2
        this.detailsForm.safety_sensors = accessControlDetail.safety_sensors
        this.detailsForm.entry_sensor = accessControlDetail.entry_sensor
        this.detailsForm.exit_sensor = accessControlDetail.exit_sensor
        this.detailsForm.boom_length = accessControlDetail.boom_length || 0
        this.detailsForm.alerts = accessControlDetail.alerts
        this.detailsForm.support_post = accessControlDetail.support_post
        this.detailsForm.breakaway = accessControlDetail.breakaway
        this.detailsForm.articulated = accessControlDetail.articulated
        this.detailsForm.door_closer = accessControlDetail.door_closer
        this.detailsForm.lock_type = accessControlDetail.lock_type
        this.detailsForm.main_lock = accessControlDetail.main_lock
        this.detailsForm.mounting_type = accessControlDetail.mounting_type
        this.detailsForm.door_thickness = accessControlDetail.door_thickness || 0
        this.detailsForm.lock_thickness = accessControlDetail.lock_thickness || 0
        this.detailsForm.handle_height = accessControlDetail.handle_height || 0
        this.detailsForm.handle_offset = accessControlDetail.handle_offset || 0
        this.detailsForm.exterior_door = accessControlDetail.exterior_door
        this.detailsForm.door_prepared_for_lock = accessControlDetail.door_prepared_for_lock
        this.detailsForm.has_reliable_wifi = accessControlDetail.has_reliable_wifi
        this.detailsForm.configure_proximity = accessControlDetail.configure_proximity
        this.detailsForm.configure_code = accessControlDetail.configure_code
        this.detailsForm.configure_fingerprint = accessControlDetail.configure_fingerprint
        this.detailsForm.configure_mobile = accessControlDetail.configure_mobile
        this.detailsForm.requires_temporary_codes = accessControlDetail.requires_temporary_codes
        this.detailsForm.hardware_standard = accessControlDetail.hardware_standard
        this.detailsForm.backset = accessControlDetail.backset || 0
        this.detailsForm.axe_distance = accessControlDetail.axe_distance || 0
        this.detailsForm.faceplate_type = accessControlDetail.faceplate_type
        this.detailsForm.faceplate_width = accessControlDetail.faceplate_width || 0
        this.detailsForm.faceplate_length = accessControlDetail.faceplate_length || 0
        this.detailsForm.cover_plate = accessControlDetail.cover_plate
        this.detailsForm.locking_devices = accessControlDetail.locking_devices
      }
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    ...mapGetters(['configuratorStepNumber']),
    accessControlComponent () {
      if (!this.controlAcceso.access_control_type || !this.controlAcceso.access_control_type.code) return

      return ACCESS_CONTROL_COMPONENTS[this.controlAcceso.access_control_type.code]
    },
    integrationNotesRequired () {
      const controlType = this.controlAcceso.access_control_type
      if (!controlType || !controlType.code) return false
      const fieldConfig = controlType.field_config

      return Object.entries(this.detailsForm).some(([key, value]) => {
        return fieldConfig.includes(key) && value === 'Especial'
      })
    }
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable({
        controlacceso: this.form,
        accessControlDetail: this.detailsForm
      })
      return result
    },
    formHasChanged () {
      return true
      // TODO: implement here the detail form check
      // return Object.entries(this.form).some(([key, value]) => value !== this.controlAcceso[key])
    },
    updateStepNotes (notes) {
      this.form.integration_notes = notes
    },
    openMotorSelectorModal () {
      this.$bvModal.show('motor-selector-modal')
    }
  }
}
</script>